import type { ContentPart } from "./opencodeTypes"

export const SHOW_REASONING_STORAGE_KEY = "moderniser_show_reasoning"

export function showReasoningFromStored(value: string | null | undefined): boolean {
  return value === "true"
}

export function readShowReasoning(): boolean {
  try {
    return showReasoningFromStored(localStorage.getItem(SHOW_REASONING_STORAGE_KEY))
  } catch {
    return false
  }
}

export function saveShowReasoning(show: boolean): void {
  try {
    localStorage.setItem(SHOW_REASONING_STORAGE_KEY, String(show))
  } catch {
    // The setting still works for this page when storage is unavailable.
  }
}

export function visibleContentParts(
  parts: ContentPart[] | undefined,
  showReasoning: boolean,
): ContentPart[] {
  if (!parts) return []
  return showReasoning ? parts : parts.filter((part) => part.type !== "reasoning")
}
